import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAsterisk = styled(Typography)(({ theme }) => ({
  color: `${theme?.palette?.labels?.bt_red_reg} !important`,
  lineHeight: 1.0,
}));
